const TEXTS = {
  INPUT: {
    LABEL: 'Attachment',
    VALUE: 'Drop files to attach or ',
    VALUE_BROWSE: ' Browse files',
    DISABLED: 'No file selected',
  },
  INVALID_FILE_TYPE: 'File type is invalid.',
};

const MIME_TYPES = {
  PDF: 'application/pdf',
  JPG: 'image/jpeg',
  TIFF: 'image/tiff',
};

const WO_SUPPORTED_FILE_FORMATS = [
  MIME_TYPES.PDF,
  MIME_TYPES.JPG,
  MIME_TYPES.TIFF,
];

export { TEXTS, WO_SUPPORTED_FILE_FORMATS };
